import { Injectable } from '@angular/core';
import { Storage } from '@ionic/storage';

@Injectable({
  providedIn: 'root'
})
export class SwstoragService {
  // Every call waits for the store to be created, so early reads/writes
  // (e.g. right after login or app reload) don't race the init.
  private ready: Promise<any>;

  constructor(private storage: Storage) {
    this.ready = this.storage.create();
  }

  setStorage(key: string, value: any): Promise<any> {
    return this.ready.then(() => this.storage.set(key, value));
  }

  getStorage(key: string): Promise<any> {
    return this.ready.then(() => this.storage.get(key));
  }

  clearStorage(): Promise<any> {
    return this.ready.then(() => this.storage.clear());
  }

  removeStorage(key: string): Promise<any> {
    return this.ready.then(() => this.storage.remove(key));
  }

}
